class JivoOpener {
    constructor(opener) {
        this.opener = opener;
        this.init();
    }

    init() {
        this.addEventListener();
    }

    addEventListener() {
        this.opener.addEventListener('click', (e) => {
            e.preventDefault();

            if (TalkMe) {
                TalkMe("openSupport");
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', init);

function init() {
    const openers = document.querySelectorAll('[data-jivo-open]');

    if (!openers.length) {
        return;
    }

    openers.forEach((opener) => {
        new JivoOpener(opener);
    });
}
